(function () {
  "use strict";

  document.querySelectorAll("[data-project-gallery]").forEach(function (root) {
    if (root.dataset.projectGalleryReady === "true") return;
    root.dataset.projectGalleryReady = "true";

    var dataNode = root.querySelector("[data-project-gallery-data]");
    if (!dataNode) return;

    var data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.error("Xtreme project gallery data could not be parsed.", error);
      return;
    }

    var projects = (data.projects || []).slice().sort(bySortOrder);
    var scenes = (data.scenes || []).slice().sort(bySortOrder);
    var hotspots = (data.hotspots || []).slice().sort(bySortOrder);
    if (!projects.length || !scenes.length) return;

    var projectNav = root.querySelector("[data-project-nav]");
    var image = root.querySelector("[data-project-image]");
    var media = root.querySelector("[data-project-media]");
    var visual = root.querySelector(".xt-project-gallery__visual");
    var hotspotLayer = root.querySelector("[data-project-hotspots]");
    var groupTabs = root.querySelector("[data-project-groups]");
    var sceneTabs = root.querySelector("[data-project-scenes]");
    var componentRow = root.querySelector("[data-project-components]");
    var archive = root.querySelector("[data-project-archive]");
    var plusIcon = root.querySelector("[data-project-plus-icon]");

    /* Photos were trimmed of baked-in white side bars. Hotspot coordinates are stored
       against the original frame, so map them into the trimmed one: [left, right] fractions. */
    var TRIM_MARGINS = { "xt-mg-01": [0.14071, 0.16143] };

    /* Two blurred backdrop layers that crossfade, so the stage is never an empty dark box. */
    var backdrops = [0, 1].map(function () {
      var layer = document.createElement("div");
      layer.className = "xt-project-gallery__backdrop";
      layer.setAttribute("aria-hidden", "true");
      if (media && image) media.insertBefore(layer, image);
      return layer;
    });
    var backdropFront = 0;

    function setBackdrop(src) {
      if (!src) return;
      var next = 1 - backdropFront;
      backdrops[next].style.backgroundImage = 'url("' + String(src).replace(/"/g, "%22") + '")';
      backdrops[next].classList.add("is-front");
      backdrops[backdropFront].classList.remove("is-front");
      backdropFront = next;
    }

    function trimFor(src) {
      var match = /(xt-mg-\d+)\.webp/.exec(src || "");
      return (match && TRIM_MARGINS[match[1]]) || null;
    }
    var viewModeButtons = root.querySelectorAll("[data-project-view-mode]");
    var viewModePanels = root.querySelectorAll("[data-project-view-panel]");
    var modelPlaceholder = root.querySelector("[data-project-model]");
    var modelRig = root.querySelector("[data-project-model-rig]");
    var hotspotDetail = root.querySelector("[data-project-hotspot-detail]");
    var hotspotDetailClose = root.querySelector("[data-project-hotspot-close]");
    var hotspotDetailMedia = root.querySelector("[data-project-hotspot-detail-media]");
    var hotspotDetailImage = root.querySelector("[data-project-hotspot-detail-image]");
    var hotspotDetailLabel = root.querySelector("[data-project-hotspot-detail-label]");
    var hotspotDetailTitle = root.querySelector("[data-project-hotspot-detail-title]");
    var hotspotDetailDescription = root.querySelector("[data-project-hotspot-detail-description]");
    var hotspotDetailLink = root.querySelector("[data-project-hotspot-detail-link]");
    var expandButton = root.querySelector("[data-project-expand]");
    var spinViewer = root.querySelector("[data-project-spin]");
    var spinImage = root.querySelector("[data-project-spin-image]");
    var spinCurrent = root.querySelector("[data-project-spin-current]");
    var spinCount = root.querySelector("[data-project-spin-count]");
    var spinTotal = root.querySelector("[data-project-spin-total]");
    var spinLabel = root.querySelector("[data-project-spin-label]");
    var spinProgress = root.querySelector("[data-project-spin-progress]");
    var spinStepButtons = root.querySelectorAll("[data-project-spin-step]");

    var fields = {
      label: root.querySelector("[data-project-label]"),
      name: root.querySelector("[data-project-name]"),
      description: root.querySelector("[data-project-description]"),
      status: root.querySelector("[data-project-status]"),
      statusDetail: root.querySelector("[data-project-status-detail]"),
      caption: root.querySelector("[data-project-scene-caption]"),
      statStatus: root.querySelector("[data-project-stat-status]"),
      statPowertrain: root.querySelector("[data-project-stat-powertrain]"),
      statCompleted: root.querySelector("[data-project-stat-completed]"),
      statLocation: root.querySelector("[data-project-stat-location]"),
      installed: root.querySelector("[data-project-installed]"),
      componentNote: root.querySelector("[data-project-component-note]"),
      sceneCurrent: root.querySelector("[data-project-scene-current]"),
      sceneTotal: root.querySelector("[data-project-scene-total]"),
      enquire: root.querySelector("[data-project-enquire]"),
      whatsapp: root.querySelector("[data-project-whatsapp]")
    };

    var state = {
      projectKey: projects[0].key,
      group: "",
      sceneKey: "",
      activeHotspot: -1,
      viewMode: "2d",
      modelYaw: -8,
      spinIndex: 0,
      expanded: false
    };

    if (projects.length === 1) root.classList.add("is-single-project");

    function bySortOrder(a, b) {
      return Number(a.sortOrder || 0) - Number(b.sortOrder || 0);
    }

    function projectScenes(projectKey) {
      return scenes.filter(function (scene) {
        return scene.projectKey === projectKey && scene.image;
      });
    }

    function currentProject() {
      return projects.find(function (project) {
        return project.key === state.projectKey;
      }) || projects[0];
    }

    function currentScene() {
      return scenes.find(function (scene) {
        return scene.key === state.sceneKey && scene.projectKey === state.projectKey;
      }) || projectScenes(state.projectKey)[0];
    }

    function spinFrames() {
      var dedicated = projectScenes(state.projectKey).filter(function (scene) {
        var group = String(scene.group || "").toLowerCase().replace("°", "");
        return group === "360" || group === "360 view" || group === "spin";
      });
      if (dedicated.length >= 4) return dedicated;

      var finished = projectScenes(state.projectKey).filter(function (scene) {
        return String(scene.group || "").toLowerCase() === "finished";
      });
      var candidates = finished.length >= 4 ? finished : projectScenes(state.projectKey);
      return candidates.slice(0, 8);
    }

    function renderSpinFrame(nextIndex) {
      if (!spinImage) return;
      var frames = spinFrames();
      if (!frames.length) return;
      state.spinIndex = ((Number(nextIndex) % frames.length) + frames.length) % frames.length;
      var frame = frames[state.spinIndex];
      spinImage.src = frame.image;
      spinImage.alt = (currentProject().name || "Project vehicle") + " 360 degree demo frame " + (state.spinIndex + 1);
      spinCurrent.textContent = String(state.spinIndex + 1).padStart(2, "0");
      spinCount.textContent = String(frames.length).padStart(2, "0");
      spinTotal.textContent = String(frames.length).padStart(2, "0");
      if (spinLabel) {
        var hasDedicatedFrames = frames.some(function (candidate) {
          var group = String(candidate.group || "").toLowerCase().replace("°", "");
          return group === "360" || group === "360 view" || group === "spin";
        });
        spinLabel.textContent = hasDedicatedFrames ? "360° view" : "360° demo";
      }
      spinProgress.style.width = ((state.spinIndex + 1) / frames.length) * 100 + "%";

      [frames[(state.spinIndex + 1) % frames.length], frames[(state.spinIndex - 1 + frames.length) % frames.length]].forEach(function (candidate) {
        var preload = new Image();
        preload.src = candidate.image;
      });
    }

    function stepSpinFrame(direction) {
      renderSpinFrame(state.spinIndex + Number(direction || 0));
    }

    function groupsFor(projectKey) {
      var seen = {};
      return projectScenes(projectKey).reduce(function (groups, scene) {
        var group = scene.group || "Project";
        if (!seen[group]) {
          seen[group] = true;
          groups.push(group);
        }
        return groups;
      }, []);
    }

    function scenesForActiveGroup() {
      return projectScenes(state.projectKey).filter(function (scene) {
        return (scene.group || "Project") === state.group;
      });
    }

    function renderProjectNav() {
      projectNav.innerHTML = "";
      projects.forEach(function (project) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "xt-project-gallery__project-card";
        button.classList.toggle("is-active", project.key === state.projectKey);
        button.setAttribute("aria-pressed", project.key === state.projectKey ? "true" : "false");

        var copy = document.createElement("span");
        copy.className = "xt-project-gallery__project-card-copy";
        var make = document.createElement("span");
        make.textContent = project.make || "Xtreme project";
        var name = document.createElement("strong");
        name.textContent = project.name || "Untitled project";
        var subtitle = document.createElement("small");
        subtitle.textContent = project.subtitle || project.status || "Workshop documented";
        copy.append(make, name, subtitle);

        var arrow = document.createElement("span");
        arrow.className = "xt-project-gallery__project-card-arrow";
        arrow.setAttribute("aria-hidden", "true");
        arrow.innerHTML = '<svg viewBox="0 0 24 24"><path d="M5 12h13M13 7l5 5-5 5"></path></svg>';
        button.append(copy, arrow);

        button.addEventListener("click", function () {
          setProject(project.key);
        });
        projectNav.appendChild(button);
      });
    }

    function renderGroups() {
      var groups = groupsFor(state.projectKey);
      groupTabs.innerHTML = "";
      groups.forEach(function (group, index) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "xt-project-gallery__chapter-tab";
        button.classList.toggle("is-active", group === state.group);
        button.setAttribute("role", "tab");
        button.setAttribute("aria-selected", group === state.group ? "true" : "false");

        var number = document.createElement("span");
        number.textContent = String(index + 1).padStart(2, "0");
        var label = document.createElement("strong");
        label.textContent = group;
        button.append(number, label);

        button.addEventListener("click", function () {
          setGroup(group);
        });
        groupTabs.appendChild(button);
      });
    }

    function renderSceneTabs() {
      var activeScenes = scenesForActiveGroup();
      sceneTabs.innerHTML = "";
      activeScenes.forEach(function (scene) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "xt-project-gallery__scene-tab";
        button.classList.toggle("is-active", scene.key === state.sceneKey);
        button.textContent = scene.label || scene.caption || "View";
        button.addEventListener("click", function () {
          setScene(scene.key);
        });
        sceneTabs.appendChild(button);
      });

      var sceneIndex = activeScenes.findIndex(function (scene) {
        return scene.key === state.sceneKey;
      });
      fields.sceneCurrent.textContent = String(Math.max(sceneIndex + 1, 1)).padStart(2, "0");
      fields.sceneTotal.textContent = String(Math.max(activeScenes.length, 1)).padStart(2, "0");
    }

    function renderSummary() {
      var project = currentProject();
      fields.label.textContent = project.buildLabel || "Xtreme workshop project";
      fields.name.textContent = project.name || "";
      fields.description.textContent = project.description || project.subtitle || "";
      fields.status.textContent = project.forSale ? "Available project" : (project.status || "Completed project");
      fields.statusDetail.textContent = project.saleLabel || project.subtitle || "Built by Xtreme 4x4";
      fields.statStatus.textContent = project.forSale ? "For sale" : (project.status || "Completed");
      fields.statPowertrain.textContent = project.powertrain || "Workshop build";
      fields.statCompleted.textContent = project.completed || "Documented";
      fields.statLocation.textContent = project.location || "Dubai";

      fields.installed.innerHTML = "";
      (project.installedHighlights || []).forEach(function (highlight) {
        var item = document.createElement("li");
        item.textContent = highlight;
        fields.installed.appendChild(item);
      });

      fields.enquire.textContent = project.forSale ? "Ask about availability" : "Enquire about this rig";
      fields.enquire.href = "/pages/contact-us?project=" + encodeURIComponent(project.key || project.name || "");

      var message = project.forSale
        ? "Hi Xtreme4x4, I want to ask about the availability of " + project.name + "."
        : "Hi Xtreme4x4, I want to know more about the " + project.name + " project.";
      fields.whatsapp.href = "https://wa.me/" + root.dataset.whatsapp + "?text=" + encodeURIComponent(message);
    }

    function renderComponents() {
      var project = currentProject();
      var highlights = project.installedHighlights || [];
      var activeScenes = scenesForActiveGroup();
      var supportingScenes = activeScenes.concat(projectScenes(state.projectKey)).filter(uniqueScene);
      componentRow.innerHTML = "";

      highlights.slice(0, 4).forEach(function (highlight, index) {
        var scene = supportingScenes[index % supportingScenes.length] || currentScene();
        var card = document.createElement("article");
        card.className = "xt-project-gallery__component-card";

        var cardImage = document.createElement("img");
        cardImage.src = scene.image;
        cardImage.alt = scene.alt || highlight;
        cardImage.loading = "lazy";
        var copy = document.createElement("div");
        var title = document.createElement("strong");
        title.textContent = highlight;
        var meta = document.createElement("span");
        meta.textContent = scene.group || "Installed by Xtreme";
        copy.append(title, meta);
        var thumb = document.createElement("span");
        thumb.className = "xt-project-gallery__thumb";
        thumb.appendChild(cardImage);
        trackImageLoad(cardImage, thumb);
        card.append(thumb, copy);
        componentRow.appendChild(card);
      });

      fields.componentNote.textContent = state.group + " chapter";
    }

    function uniqueScene(scene, index, list) {
      return list.findIndex(function (candidate) {
        return candidate.key === scene.key;
      }) === index;
    }

    function renderHotspots() {
      var scene = currentScene();
      var activeHotspots = hotspots.filter(function (hotspot) {
        return hotspot.projectKey === state.projectKey && hotspot.sceneKey === scene.key;
      });
      hotspotLayer.innerHTML = "";
      state.activeHotspot = -1;
      closeHotspotDetail();

      activeHotspots.forEach(function (hotspot, index) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "xt-project-gallery__hotspot";
        button.style.visibility = "hidden";
        button.dataset.hotspotIndex = String(index);
        var trim = trimFor(scene.image);
        button.dataset.x = String(trim ? ((hotspot.x / 100 - trim[0]) / (1 - trim[0] - trim[1])) * 100 : hotspot.x);
        button.dataset.y = String(hotspot.y);
        button.setAttribute("aria-label", hotspot.label + (hotspot.description ? ": " + hotspot.description : ""));

        var icon = document.createElement("span");
        icon.setAttribute("aria-hidden", "true");
        if (plusIcon) icon.innerHTML = plusIcon.innerHTML;
        var label = document.createElement("strong");
        label.textContent = hotspot.label;
        button.append(icon, label);

        button.addEventListener("click", function () {
          if (state.activeHotspot === index && hotspotDetail && hotspotDetail.classList.contains("is-active")) {
            closeHotspotDetail();
            return;
          }
          state.activeHotspot = index;
          hotspotLayer.querySelectorAll(".xt-project-gallery__hotspot").forEach(function (item, itemIndex) {
            item.classList.toggle("is-active", itemIndex === index);
          });
          fields.componentNote.textContent = hotspot.description || hotspot.label;
          showHotspotDetail(hotspot);
        });
        hotspotLayer.appendChild(button);
      });

      positionHotspots();
    }

    function showHotspotDetail(hotspot) {
      if (!hotspotDetail) return;
      var product = hotspot.product || {};
      var hasProduct = Boolean(product.url);
      var title = product.title || hotspot.label || "Installed component";
      var description = hotspot.description || (hasProduct
        ? "Installed and verified by the Xtreme 4x4 workshop."
        : "Ask our workshop team for the exact specification used on this build.");

      hotspotDetailLabel.textContent = hasProduct ? "Shop this installed part" : "Installed on this build";
      hotspotDetailTitle.textContent = title;
      hotspotDetailDescription.textContent = description;

      if (product.image) {
        hotspotDetailImage.src = product.image;
        hotspotDetailImage.alt = product.title || hotspot.label || "Installed product";
        hotspotDetailMedia.classList.remove("is-empty");
        hotspotDetail.classList.add("has-image");
      } else {
        hotspotDetailImage.removeAttribute("src");
        hotspotDetailImage.alt = "";
        hotspotDetailMedia.classList.add("is-empty");
        hotspotDetail.classList.remove("has-image");
      }

      if (hasProduct) {
        hotspotDetailLink.href = product.url;
        hotspotDetailLink.textContent = "View product";
      } else {
        var message = "Hi Xtreme4x4, I want details about " + title + " on the " + currentProject().name + " project.";
        hotspotDetailLink.href = "https://wa.me/" + root.dataset.whatsapp + "?text=" + encodeURIComponent(message);
        hotspotDetailLink.textContent = "Ask about this part";
      }

      hotspotDetail.classList.add("is-active");
      scheduleAutoplay();
      hotspotDetail.setAttribute("aria-hidden", "false");
    }

    function closeHotspotDetail() {
      if (!hotspotDetail) return;
      hotspotDetail.classList.remove("is-active");
      scheduleAutoplay();
      hotspotDetail.setAttribute("aria-hidden", "true");
      state.activeHotspot = -1;
      hotspotLayer.querySelectorAll(".xt-project-gallery__hotspot").forEach(function (item) {
        item.classList.remove("is-active");
      });
      if (state.group) fields.componentNote.textContent = state.group + " chapter";
    }

    /* Smart fit: fill the stage (cover) when little of the photo would be cropped,
       otherwise show it whole (contain) on the blurred backdrop. The enlarged viewer
       always shows the whole photo. Subjects sit low in these shots, so bias the crop down. */
    var COVER_MIN_VISIBLE = 0.66;
    var FOCUS_X = 0.5;
    var FOCUS_Y = 0.6;

    function positionHotspots() {
      var scene = currentScene();
      if (!scene || !media || !image.naturalWidth) return;

      var mediaWidth = media.clientWidth;
      var mediaHeight = media.clientHeight;
      var imageWidth = image.naturalWidth || Number(scene.width) || 1600;
      var imageHeight = image.naturalHeight || Number(scene.height) || 900;
      var stageRatio = mediaWidth / mediaHeight;
      var imageRatio = imageWidth / imageHeight;
      var visibleShare = Math.min(stageRatio / imageRatio, imageRatio / stageRatio);
      var cover = !state.expanded && visibleShare >= COVER_MIN_VISIBLE;

      image.classList.toggle("is-cover", cover);
      media.classList.toggle("is-cover", cover);
      image.style.objectPosition = cover ? FOCUS_X * 100 + "% " + FOCUS_Y * 100 + "%" : "";

      var scale = cover
        ? Math.max(mediaWidth / imageWidth, mediaHeight / imageHeight)
        : Math.min(mediaWidth / imageWidth, mediaHeight / imageHeight);
      var renderedWidth = imageWidth * scale;
      var renderedHeight = imageHeight * scale;
      var offsetX = (mediaWidth - renderedWidth) * (cover ? FOCUS_X : 0.5);
      var offsetY = (mediaHeight - renderedHeight) * (cover ? FOCUS_Y : 0.5);

      hotspotLayer.querySelectorAll("[data-x][data-y]").forEach(function (button) {
        var left = offsetX + (Number(button.dataset.x) / 100) * renderedWidth;
        var top = offsetY + (Number(button.dataset.y) / 100) * renderedHeight;
        button.style.left = left + "px";
        button.style.top = top + "px";
        button.style.visibility = left < 14 || top < 14 || left > mediaWidth - 14 || top > mediaHeight - 14 ? "hidden" : "";
      });
    }

    /* Slider: arrows, dots and gentle auto-advance through the active chapter's photos.
       Autoplay pauses on hover/focus, while a pin card is open, in the enlarged viewer, when the
       tab or the slider is off screen, and never runs for reduced-motion users. */
    /* Site X-logo loader: a pulsing logo over any photo area until its image has loaded. */
    function trackImageLoad(img, host) {
      host.classList.add("xtpg-loading");
      var finish = function () {
        host.classList.remove("xtpg-loading");
        host.classList.add("xtpg-loaded");
      };
      if (img.complete && img.naturalWidth) finish();
      else {
        img.addEventListener("load", finish, { once: true });
        img.addEventListener("error", finish, { once: true });
      }
    }

    var stageLoader = document.createElement("div");
    stageLoader.className = "xt-project-gallery__stage-loader";
    stageLoader.setAttribute("aria-hidden", "true");
    if (media) media.appendChild(stageLoader);

    var AUTOPLAY_MS = 5500;
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var autoplayTimer = null;
    var hoverPaused = false;
    var inView = true;

    var prevButton = document.createElement("button");
    prevButton.type = "button";
    prevButton.className = "xt-project-gallery__arrow xt-project-gallery__arrow--prev";
    prevButton.setAttribute("aria-label", "Previous photo");
    prevButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14.5 5.5-6.5 6.5 6.5 6.5"></path></svg>';
    var nextButton = document.createElement("button");
    nextButton.type = "button";
    nextButton.className = "xt-project-gallery__arrow xt-project-gallery__arrow--next";
    nextButton.setAttribute("aria-label", "Next photo");
    nextButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9.5 5.5 6.5 6.5-6.5 6.5"></path></svg>';
    var dotsWrap = document.createElement("div");
    dotsWrap.className = "xt-project-gallery__dots";
    dotsWrap.setAttribute("role", "group");
    dotsWrap.setAttribute("aria-label", "Choose photo");
    if (media) media.append(prevButton, nextButton, dotsWrap);

    function stepScene(direction) {
      var list = scenesForActiveGroup();
      if (list.length < 2) return;
      var index = list.findIndex(function (scene) { return scene.key === state.sceneKey; });
      var next = list[(index + direction + list.length) % list.length];
      setScene(next.key);
    }

    function renderDots() {
      var list = scenesForActiveGroup();
      var many = list.length > 1;
      prevButton.hidden = !many;
      nextButton.hidden = !many;
      dotsWrap.hidden = !many;
      dotsWrap.innerHTML = "";
      if (!many) return;
      list.forEach(function (scene, i) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "xt-project-gallery__dot";
        dot.setAttribute("aria-label", "Photo " + (i + 1) + " of " + list.length + (scene.label ? ": " + scene.label : ""));
        if (scene.key === state.sceneKey) {
          dot.classList.add("is-active");
          dot.setAttribute("aria-current", "true");
          dot.style.setProperty("--xtpg-autoplay", AUTOPLAY_MS + "ms");
        }
        dot.addEventListener("click", function () { setScene(scene.key); });
        dotsWrap.appendChild(dot);
      });
      dotsWrap.classList.toggle("is-playing", canAutoplay());
    }

    function canAutoplay() {
      var detailOpen = hotspotDetail && hotspotDetail.classList.contains("is-active");
      return !reduceMotion && !hoverPaused && inView && !document.hidden && !state.expanded &&
        state.viewMode === "2d" && !detailOpen && scenesForActiveGroup().length > 1;
    }

    function scheduleAutoplay() {
      window.clearTimeout(autoplayTimer);
      autoplayTimer = null;
      dotsWrap.classList.toggle("is-playing", canAutoplay());
      if (!canAutoplay()) return;
      autoplayTimer = window.setTimeout(function () {
        if (canAutoplay()) stepScene(1); else scheduleAutoplay();
      }, AUTOPLAY_MS);
    }

    function restartAutoplay() {
      renderDots();
      scheduleAutoplay();
    }

    prevButton.addEventListener("click", function () { stepScene(-1); });
    nextButton.addEventListener("click", function () { stepScene(1); });
    if (media) {
      media.addEventListener("mouseenter", function () { hoverPaused = true; scheduleAutoplay(); });
      media.addEventListener("mouseleave", function () { hoverPaused = false; restartAutoplay(); });
      media.addEventListener("keydown", function (event) {
        if (event.key === "ArrowLeft") { event.preventDefault(); stepScene(-1); }
        if (event.key === "ArrowRight") { event.preventDefault(); stepScene(1); }
      });
      var touchStartX = null;
      media.addEventListener("touchstart", function (event) {
        touchStartX = event.touches.length === 1 ? event.touches[0].clientX : null;
      }, { passive: true });
      media.addEventListener("touchend", function (event) {
        if (touchStartX === null) return;
        var dx = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(dx) > 45) stepScene(dx < 0 ? 1 : -1);
      }, { passive: true });
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          var visible = entries[0].isIntersecting;
          if (visible !== inView) { inView = visible; restartAutoplay(); }
        }, { threshold: 0.35 }).observe(media);
      }
    }
    document.addEventListener("visibilitychange", restartAutoplay);

    function setScene(sceneKey) {
      var scene = scenes.find(function (candidate) {
        return candidate.key === sceneKey && candidate.projectKey === state.projectKey;
      });
      if (!scene) return;

      state.sceneKey = scene.key;
      state.group = scene.group || state.group || "Project";
      var token = ++switchToken;
      var firstPaint = !image.getAttribute("src");

      // The controls respond immediately; the photo area waits until the next photo is ready.
      renderSceneTabs();
      renderComponents();
      renderGroups();
      renderDots();
      scheduleAutoplay();

      var commit = function () {
        if (token !== switchToken) return;
        media.classList.remove("is-switching");
        if (!firstPaint) spawnGhost();
        if (firstPaint) image.classList.remove("is-ready");
        image.src = scene.image;
        setBackdrop(scene.image);
        image.alt = scene.alt || scene.caption || currentProject().name;
        fields.caption.textContent = scene.caption || scene.label || "";
        renderHotspots();
        image.classList.remove("is-entering");
        if (!firstPaint && !reduceMotion) {
          void image.offsetWidth;
          image.classList.add("is-entering");
        }
        if (image.complete && image.naturalWidth) {
          image.classList.add("is-ready");
          positionHotspots();
        }
      };

      if (firstPaint || !scene.image) {
        commit();
        return;
      }
      // Keep the current photo on screen while the next one downloads, then crossfade.
      media.classList.add("is-switching");
      var preload = new Image();
      preload.onload = commit;
      preload.onerror = commit;
      preload.src = scene.image;
    }

    var switchToken = 0;

    function spawnGhost() {
      if (reduceMotion || !image.naturalWidth) return;
      var ghost = image.cloneNode(false);
      ghost.removeAttribute("data-project-image");
      ghost.removeAttribute("id");
      ghost.className = image.className.replace("is-entering", "").trim() + " xt-project-gallery__ghost";
      ghost.alt = "";
      ghost.setAttribute("aria-hidden", "true");
      ghost.style.objectPosition = image.style.objectPosition;
      media.insertBefore(ghost, image.nextSibling);
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { ghost.classList.add("is-leaving"); });
      });
      window.setTimeout(function () { if (ghost.parentNode) ghost.parentNode.removeChild(ghost); }, 1000);
    }

    function setGroup(group) {
      state.group = group;
      var firstScene = projectScenes(state.projectKey).find(function (scene) {
        return (scene.group || "Project") === group;
      });
      if (firstScene) setScene(firstScene.key);
    }

    function setProject(projectKey) {
      var project = projects.find(function (candidate) {
        return candidate.key === projectKey;
      });
      if (!project) return;

      state.projectKey = project.key;
      state.spinIndex = 0;
      var projectGroups = groupsFor(project.key);
      state.group = projectGroups[0] || "Project";
      var firstScene = projectScenes(project.key)[0];
      state.sceneKey = firstScene ? firstScene.key : "";

      renderProjectNav();
      renderSummary();
      renderArchive();
      setScene(state.sceneKey);
      renderSpinFrame(0);
    }

    function setViewMode(mode) {
      if (mode !== "2d" && mode !== "360" && mode !== "3d") return;
      state.viewMode = mode;
      media.dataset.viewMode = mode;
      scheduleAutoplay();

      viewModeButtons.forEach(function (button) {
        var isActive = button.dataset.projectViewMode === mode;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      viewModePanels.forEach(function (panel) {
        var isActive = panel.dataset.projectViewPanel === mode;
        panel.classList.toggle("is-active", isActive);
        panel.setAttribute("aria-hidden", isActive ? "false" : "true");
        if (panel.hasAttribute("tabindex")) panel.tabIndex = isActive ? 0 : -1;
      });
      image.setAttribute("aria-hidden", mode === "2d" ? "false" : "true");
      if (mode !== "2d") closeHotspotDetail();
      if (mode === "360") renderSpinFrame(state.spinIndex);
    }

    function setExpanded(shouldExpand) {
      if (!visual || !expandButton) return;
      state.expanded = Boolean(shouldExpand);
      visual.classList.toggle("is-expanded", state.expanded);
      document.body.classList.toggle("xtpg-viewer-open", state.expanded);
      expandButton.setAttribute("aria-pressed", state.expanded ? "true" : "false");
      expandButton.setAttribute("aria-label", state.expanded ? "Close enlarged viewer" : "Open enlarged viewer");
      window.setTimeout(positionHotspots, 50);
      restartAutoplay();
    }

    function updateModelYaw() {
      if (modelPlaceholder) modelPlaceholder.style.setProperty("--xtpg-model-yaw", state.modelYaw + "deg");
      if (modelRig) modelRig.style.setProperty("--xtpg-model-yaw", state.modelYaw + "deg");
    }

    viewModeButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        setViewMode(button.dataset.projectViewMode);
      });
    });

    if (hotspotDetailClose) {
      hotspotDetailClose.addEventListener("click", closeHotspotDetail);
    }

    if (expandButton) {
      expandButton.addEventListener("click", function () {
        setExpanded(!state.expanded);
      });
    }

    spinStepButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.stopPropagation();
        stepSpinFrame(Number(button.dataset.projectSpinStep));
      });
    });

    if (spinViewer) {
      var spinDrag = {
        active: false,
        lastX: 0
      };

      spinViewer.addEventListener("pointerdown", function (event) {
        if (event.target.closest("[data-project-spin-step]")) return;
        spinDrag.active = true;
        spinDrag.lastX = event.clientX;
        spinViewer.classList.add("is-dragging");
        spinViewer.setPointerCapture(event.pointerId);
      });

      spinViewer.addEventListener("pointermove", function (event) {
        if (!spinDrag.active) return;
        var delta = event.clientX - spinDrag.lastX;
        if (Math.abs(delta) < 34) return;
        stepSpinFrame(delta > 0 ? -1 : 1);
        spinDrag.lastX = event.clientX;
      });

      function endSpinDrag(event) {
        if (!spinDrag.active) return;
        spinDrag.active = false;
        spinViewer.classList.remove("is-dragging");
        if (spinViewer.hasPointerCapture(event.pointerId)) {
          spinViewer.releasePointerCapture(event.pointerId);
        }
      }

      spinViewer.addEventListener("pointerup", endSpinDrag);
      spinViewer.addEventListener("pointercancel", endSpinDrag);
      spinViewer.addEventListener("keydown", function (event) {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.preventDefault();
        stepSpinFrame(event.key === "ArrowLeft" ? -1 : 1);
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      closeHotspotDetail();
      if (state.expanded) setExpanded(false);
    });

    if (modelPlaceholder && modelRig) {
      var modelDrag = {
        active: false,
        startX: 0,
        startYaw: state.modelYaw
      };

      modelPlaceholder.addEventListener("pointerdown", function (event) {
        modelDrag.active = true;
        modelDrag.startX = event.clientX;
        modelDrag.startYaw = state.modelYaw;
        modelPlaceholder.classList.add("is-dragging");
        modelPlaceholder.setPointerCapture(event.pointerId);
      });

      modelPlaceholder.addEventListener("pointermove", function (event) {
        if (!modelDrag.active) return;
        state.modelYaw = Math.max(-38, Math.min(38, modelDrag.startYaw + (event.clientX - modelDrag.startX) * 0.35));
        updateModelYaw();
      });

      function endModelDrag(event) {
        if (!modelDrag.active) return;
        modelDrag.active = false;
        modelPlaceholder.classList.remove("is-dragging");
        if (modelPlaceholder.hasPointerCapture(event.pointerId)) {
          modelPlaceholder.releasePointerCapture(event.pointerId);
        }
      }

      modelPlaceholder.addEventListener("pointerup", endModelDrag);
      modelPlaceholder.addEventListener("pointercancel", endModelDrag);
      modelPlaceholder.addEventListener("keydown", function (event) {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.preventDefault();
        state.modelYaw = Math.max(-38, Math.min(38, state.modelYaw + (event.key === "ArrowLeft" ? -8 : 8)));
        updateModelYaw();
      });
      updateModelYaw();
    }

    function renderArchive() {
      archive.innerHTML = "";
      var archiveItems = [];

      if (projects.length > 1) {
        archiveItems = projects.map(function (project) {
          var scene = projectScenes(project.key)[0];
          return {
            projectKey: project.key,
            group: scene ? scene.group : "",
            image: scene ? scene.image : "",
            alt: scene ? scene.alt : project.name,
            badge: project.forSale ? "For sale" : (project.status || "Completed"),
            title: project.name,
            subtitle: project.subtitle || project.buildLabel
          };
        });
      } else {
        var project = currentProject();
        archiveItems = groupsFor(project.key).map(function (group) {
          var scene = projectScenes(project.key).find(function (candidate) {
            return (candidate.group || "Project") === group;
          });
          return {
            projectKey: project.key,
            group: group,
            image: scene ? scene.image : "",
            alt: scene ? scene.alt : project.name,
            badge: group,
            title: project.name,
            subtitle: scene ? scene.caption : project.subtitle
          };
        });

        if (archiveItems.length && archiveItems.length < 5) {
          var finalScene = projectScenes(project.key)[projectScenes(project.key).length - 1];
          archiveItems.push({
            projectKey: project.key,
            group: finalScene.group,
            sceneKey: finalScene.key,
            image: finalScene.image,
            alt: finalScene.alt,
            badge: "Full story",
            title: project.name,
            subtitle: "Explore all " + projectScenes(project.key).length + " documented images"
          });
        }
      }

      archiveItems.slice(0, 5).forEach(function (item) {
        var card = document.createElement("button");
        card.type = "button";
        card.className = "xt-project-gallery__archive-card";

        var cardMedia = document.createElement("div");
        cardMedia.className = "xt-project-gallery__archive-media";
        var cardImage = document.createElement("img");
        cardImage.src = item.image;
        cardImage.alt = item.alt || item.title;
        cardImage.loading = "lazy";
        var badge = document.createElement("span");
        badge.textContent = item.badge;
        cardMedia.append(cardImage, badge);
        trackImageLoad(cardImage, cardMedia);

        var copy = document.createElement("div");
        copy.className = "xt-project-gallery__archive-copy";
        var title = document.createElement("strong");
        title.textContent = item.title;
        var subtitle = document.createElement("span");
        subtitle.textContent = item.subtitle || "Xtreme workshop project";
        copy.append(title, subtitle);
        card.append(cardMedia, copy);

        card.addEventListener("click", function () {
          if (state.projectKey !== item.projectKey) {
            setProject(item.projectKey);
          }
          if (item.sceneKey) {
            setScene(item.sceneKey);
          } else if (item.group) {
            setGroup(item.group);
          }
          root.querySelector(".xt-project-gallery__workspace").scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        });
        archive.appendChild(card);
      });
    }

    image.addEventListener("load", function () {
      image.classList.add("is-ready");
      positionHotspots();
    });

    window.addEventListener("resize", positionHotspots, { passive: true });

    var exploreButton = root.querySelector("[data-project-explore]");
    if (exploreButton) {
      exploreButton.addEventListener("click", function () {
        root.querySelector(".xt-project-gallery__archive").scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    }

    setViewMode(state.viewMode);
    setProject(state.projectKey);
  });
})();
